import React from 'react';
import { createPortal } from 'react-dom';

/* Тёмное окно подтверждения выхода (общее для кабинета и админки).
   Рендерится через портал в body, чтобы overflow/позиционирование
   сайдбара не обрезали окно. */
export default function LogoutModal({ open, onClose, onConfirm }) {
  if (!open) return null;
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dark" onClick={e => e.stopPropagation()}>
        <div className="modal-ic">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </div>
        <h3 className="modal-h">Выйти из аккаунта?</h3>
        <p className="modal-p">Вы вернётесь на страницу входа и сможете войти снова в любой момент.</p>
        <div className="modal-actions">
          <button className="modal-ghost" onClick={onClose}>Отмена</button>
          <button className="modal-danger" onClick={onConfirm}>Выйти</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
